// extracted by mini-css-extract-plugin
export default {"row":"row_row__tt3In","row__group":"row_row__group__Pg-0a"};